import { useTranslation } from "react-i18next";
import { titleCase } from "title-case";
import titleCaseFrench from "titlecase-french";

export const toSentenceCase = (text: string) => {
  return text?.replace(/(?:^|[?!.])\s*(\w)/g, (match) => match.toUpperCase());
};
export const useConvertCase = () => {
  const { i18n } = useTranslation();
  const toTitleCase = (text: string) => {
    switch (i18n.resolvedLanguage) {
      case "en":
        return titleCase(text);
      case "fr":
        return titleCaseFrench.convert(text);
      default:
        return toSentenceCase(text);
    }
  };
  return { toTitleCase, toSentenceCase };
};
